import Image from '@tiptap/extension-image';

export const InlineImage = Image.extend({
    addAttributes() {
        return {
            ...this.parent?.(),
            width: {
                default: null,
                parseHTML: element => element.getAttribute('width'),
                renderHTML: attributes => {
                    if (!attributes.width) {
                        return {};
                    }
                    return { width: attributes.width };
                }
            }
        };
    }
});
